var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-secondary",attrs:{"outlined":"","small":_vm.small},on:{"click":_vm.toggle}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.shown ? 'mdi-eye-off' : 'mdi-translate'))]),_vm._v(" "+_vm._s(_vm.shown ? 'پنهان کردن فیلدهای انگلیسی' : 'نمایش فیلدهای انگلیسی')+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }